import { Avatar } from 'antd';
import dayjs from 'dayjs';
import React from 'react'
import { FaStar } from 'react-icons/fa';

const ReviewContent = ({ data: review }) => {

    const getCustomormattedDateTime = (dateTime) => {
        if (!dateTime) return ''

        return dayjs(dateTime).format("MMM DD, YYYY hh.mm A");
    }

    return (
        <div className='flex sm:justify-between sm:items-center mb-1'>
            <div className='h-[60px] mr-3'>
                <Avatar
                    src={review?.user?.imageThumbUrl}
                    className='w-full h-full aspect-square object-cover'
                    size={'small'}
                />
            </div>
            <div>
                <div className='flex sm:flex-row flex-col sm:items-end mb-[2px]'>
                    <p className='text-lg font-semibold mr-4'>
                        {review?.user?.fullName && review?.user?.fullName.length > 10 ? 
                        review?.user?.fullName.slice(0,10)+'...' : review?.user?.fullName}
                    </p>
                    <p className='text-xs mb-[4px] '>
                        {getCustomormattedDateTime(review?.createdAt)}
                    </p>
                </div>
                <div className='flex flex-col'>
                    <div className='sm:order-1 order-2'>
                        {review?.comment ? (
                            <p className='sm:mb-2 mb-4 text-xs'>{review?.comment}</p>
                        ) : ''}
                    </div>
                    <div className='sm:mb-2 mb-0 ratings sm:mr-2 mr-0 flex rounded-md sm:order-2 order-1'>
                        {/* rated stars count */}
                        {
                            Array(Math.floor(review?.rating))
                                .fill(0).map((el, index) => (
                                    <FaStar key={'rated' + index} size={14} className='text-primary mr-[2px]' />
                                ))
                        }

                        {/* unrated stars count */}
                        {
                            Array(5 - Math.floor(review?.rating))
                                .fill(0).map((el, index) => (
                                    <FaStar key={'unrated' + index} size={14} className='text-gray-200 mr-[2px]' />
                                ))
                        }
                        <span className='ml-2 text-gray-300 font-semibold text-xs inline-block mt-[1px]'>{review?.rating.toFixed(2)}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReviewContent